import store from '@/store'
import { getOfferConfig } from '@/config/remote.config'

const guard = (to, from, next) => {
  (async () => {
    if (to.name === 'home' && to.params.offer) {
      const offerConfig = await getOfferConfig(to.params.offer)
      if (offerConfig) {
        const offerCurrent = {
          ...offerConfig
        }
        if (!offerCurrent.offer || !offerCurrent.offer.hero) {
          offerCurrent.offer = {
            hero: {
              alt: '',
              sm: '/img/hero-sm.jpg',
              md: '',
              lg: '/img/hero-lg.jpg'
            }
          }
        }

        if (offerCurrent.requiresCoupon && !to.query.coupon) {
          return next(false)
        }

        if (offerCurrent.period) {
          const now = new Date()
          if (now < new Date(offerCurrent.period.start) || now > new Date(offerCurrent.period.end)) {
            return next(false)
          }
        }

        store.commit('offers/SET_OFFER_CURRENT', offerCurrent)
        next()
      } else {
        next(false)
      }
    } else {
      next(false)
    }
  })()
}

export default guard
